import React, { useEffect, useState, useRef, useCallback } from "react";
import mapboxgl from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchData } from "../redux/apiSlice";
import { toastify, userlogout, clearuser } from "../redux/controller";
import { db } from "../redux/firebase";
import {
  collection,
  query,
  where,
  onSnapshot,
  doc,
  getDocs
} from "firebase/firestore";
import { getMessaging } from "firebase/messaging";

export default function RealtrackingDetails() {
  const messaging = getMessaging();
  const mapRef = useRef(null);
  const drawRef = useRef(null);
  const initialized = useRef(false);
  const unsubscribeRef = useRef(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const usertoken = useSelector((state) => state.userdata.usertoken);
  const propertyid = queryParams.get("property");
  const [property, setProperty] = useState({});
  const userlist = location.state.users;
  const navigate = useNavigate();
  const [realpopup, setRealpopup] = useState(false);
  const [popup, setPopUp] = useState(false);
  const [selectedhunter, setselectedhunter] = useState({});
  const [selectedhuntertoken, setselectedhuntertoken] = useState("");
  const [allhunterstoken, setallhunterstoken] = useState([]);
  const [mapLoaded, setMapLoaded] = useState(false);
  
  const [stepinputField, setstepInputField] = useState({
    description: ""
  });

  const [setStepAllDescription, setStepAll] = useState({
    description: ""
  });

  const [allHunters, setAllHunters] = useState([]);
  const dispatch = useDispatch();
  const [selectedmapstyles] = useState("mapbox://styles/mapbox/satellite-streets-v12");
  
  // Extract user IDs for filtering
  const hunterIds = useRef(userlist.map(user => user._id));
  const reservationIds = useRef(userlist.map(user => user.reservationid));

  const handleClosepopup = () => {
    setRealpopup(false);
    setPopUp(false);
  };

  const handlepopup = () => {
    setRealpopup(true);
  };

  const handleSend = () => {
    sendNotificationToHunter(selectedhuntertoken, stepinputField.description, false);
  };

  const handleSendToAll = () => {
    setPopUp(true);
  };

  const sendMessageToAll = () => {
    if (allhunterstoken.length > 0) {
      allhunterstoken.forEach((tokenData, index) => {
        const isLast = index === allhunterstoken.length - 1;
        sendNotificationToHunter(
          tokenData.firebase_token, 
          setStepAllDescription.description, 
          isLast ? 'all' : ''
        );
      });
    }
  };

  const sendNotificationToHunter = async (udid, message, all) => {
    if (message) {
      try {
        const response = await dispatch(fetchData({
          apiurl: "/reservation/send/notification",
          messagingtoken: udid,
          message,
          propertyname: property.title,
          type: "FromTracking",
          headers: { "x-access-token": usertoken }
        }));
        
        setstepInputField({ description: "" });
        setStepAll({ description: "" });
        
        if (all === "all") {
          toastify({message: "Notification sent to all hunters successfully"});
          handleClosepopup();
          return;
        }
        
        if (response.payload && response.payload.status === 200) {
          toastify({ message: response.payload.message });
        } else {
          toastify({ message: response.payload.message });
          if (response.payload.response.data.message === "Invalid token provided!" || 
              response.payload.response.data.message === "No token provided!") {
            clearuser();
            userlogout();
            navigate('/');
            window.location.reload();
          }
        }
        handleClosepopup();
      } catch (error) {
        console.error("Error sending notification:", error);
        toastify({ message: "Failed to send notification" });
      }
    }
  };

  // Memoized function to update markers
  const updateMarkers = useCallback((map, users, propertys) => {
    if (!map || !map.getStyle()) return;
    
    const validTokens = [];
    
    // Process only the users we're tracking
    hunterIds.current.forEach((hunterId, index) => {
      const reservationId = reservationIds.current[index];
      const trackuser = users.find(u => 
        u.user_id === hunterId && u.reservation_id === reservationId
      );
      
      if (trackuser) {
        validTokens.push(trackuser);
        
        const sourceId = `markers-${hunterId}-${reservationId}`;
        const layerId = `markers-layer-${hunterId}-${reservationId}`;
        
        // Check if source exists
        if (map.getSource(sourceId)) {
          // Update existing source
          map.getSource(sourceId).setData({
            type: 'FeatureCollection',
            features: [{
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [trackuser.longitude, trackuser.latitude]
              },
              properties: {
                user: JSON.stringify(userlist[index]),
                user_token: trackuser.firebase_token
              }
            }]
          });
        } else {
          // Create new source and layer
          map.addSource(sourceId, {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: [{
                type: 'Feature',
                geometry: {
                  type: 'Point',
                  coordinates: [trackuser.longitude, trackuser.latitude]
                },
                properties: {
                  user: JSON.stringify(userlist[index]),
                  user_token: trackuser.firebase_token
                }
              }]
            }
          });
          
          map.addLayer({
            id: layerId,
            source: sourceId,
            type: 'circle',
            paint: {
              'circle-radius': 10,
              'circle-color': '#be7637',
              'circle-stroke-width': 2,
              'circle-stroke-color': '#fff'
            }
          });
          
          // Add click event only once
          map.on('click', layerId, (e) => {
            if (e.features && e.features.length > 0) {
              handlepopup();
              setselectedhunter(JSON.parse(e.features[0].properties.user));
              setselectedhuntertoken(e.features[0].properties.user_token);
            }
          });
          
          // Change cursor on hover
          map.on('mouseenter', layerId, () => {
            map.getCanvas().style.cursor = 'pointer';
          });
          
          map.on('mouseleave', layerId, () => {
            map.getCanvas().style.cursor = '';
          });
        }
      } else {
        // Remove source and layer if user is no longer in the tracked list
        const sourceId = `markers-${hunterId}-${reservationId}`;
        const layerId = `markers-layer-${hunterId}-${reservationId}`;
        
        if (map.getLayer(layerId)) {
          map.removeLayer(layerId);
        }
        if (map.getSource(sourceId)) {
          map.removeSource(sourceId);
        }
      }
    });
    
    setallhunterstoken(validTokens);
  }, [userlist]);

  // Setup Firebase listener with optimized query
  const setupFirebaseListener = useCallback((map, propertys) => {
    // Clean up previous listener if exists
    if (unsubscribeRef.current) {
      unsubscribeRef.current();
    }
    
    // Create a query that only listens for the users we care about
    const usersQuery = query(
      collection(db, "users_location"),
      where("user_id", "in", hunterIds.current.slice(0, 10)) // Firestore limits "in" to 10 items
    );
    
    // For more than 10 users, we need to chunk the queries
    if (hunterIds.current.length > 10) {
      // We'll need to create multiple queries and combine them
      const chunkSize = 10;
      const chunks = [];
      
      for (let i = 0; i < hunterIds.current.length; i += chunkSize) {
        const chunk = hunterIds.current.slice(i, i + chunkSize);
        chunks.push(query(
          collection(db, "users_location"),
          where("user_id", "in", chunk)
        ));
      }
      
      // For simplicity, we'll just get the data once instead of real-time updates
      // for users beyond the first 10, or you could implement a more complex solution
      Promise.all(chunks.map(chunkQuery => getDocs(chunkQuery)))
        .then((results) => {
          const allUsers = [];
          results.forEach(result => {
            result.forEach(doc => {
              allUsers.push(doc.data());
            });
          });
          updateMarkers(map, allUsers, propertys);
        })
        .catch(error => {
          console.error("Error fetching user locations:", error);
        });
    }
    
    // Set up real-time listener for the first 10 users
    unsubscribeRef.current = onSnapshot(usersQuery, (querySnapshot) => {
      const users = [];
      querySnapshot.forEach((doc) => {
        users.push(doc.data());
      });
      
      // Use requestAnimationFrame to avoid blocking the UI
      requestAnimationFrame(() => {
        updateMarkers(map, users, propertys);
      });
    }, (error) => {
      console.error("Error in Firebase listener:", error);
    });
  }, [updateMarkers]);

  // Draw property boundaries and slots
  const drawPropertyBoundaries = useCallback((map, propertys) => {
    if (!map || !propertys.payload.data.geodraw) return;
    
    // Add main property boundary
    if (map.getSource('maine')) {
      map.getSource('maine').setData({
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: propertys.payload.data.geodraw.coords.paths
        }
      });
    } else {
      map.addSource('maine', {
        type: 'geojson',
        data: {
          type: 'Feature',
          geometry: {
            type: 'Polygon',
            coordinates: propertys.payload.data.geodraw.coords.paths
          }
        }
      });
      
      map.addLayer({
        id: 'outline',
        type: 'line',
        source: 'maine',
        layout: {},
        paint: {
          'line-color': propertys.payload.data.propertycolor,
          'line-width': 3
        }
      });
    }
    
    // Add area slots
    if (propertys.payload.data.area) {
      propertys.payload.data.area.forEach((area, y) => {
        if (area.slots && area.slots.length) {
          area.slots.forEach((slot, x) => {
            if (slot && slot.name && slot.coords) {
              const sourceId = `maine-${y}-${x}`;
              const layerId = `outline-${y}-${x}`;
              
              if (map.getSource(sourceId)) {
                map.getSource(sourceId).setData({
                  type: 'Feature',
                  geometry: {
                    type: 'Polygon',
                    coordinates: slot.coords.paths
                  },
                  properties: {
                    title: `A${y}-${x}`
                  }
                });
              } else {
                map.addSource(sourceId, {
                  type: 'geojson',
                  data: {
                    type: 'Feature',
                    geometry: {
                      type: 'Polygon',
                      coordinates: slot.coords.paths
                    },
                    properties: {
                      title: `A${y}-${x}`
                    }
                  }
                });
                
                map.addLayer({
                  id: layerId,
                  type: 'line',
                  source: sourceId,
                  layout: {},
                  paint: {
                    'line-color': area.areacolor,
                    'line-width': 3
                  }
                });
              }
            }
          });
        }
      });
    }
  }, []);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      fetchBlogs();
    }
    
    // Cleanup function
    return () => {
      if (unsubscribeRef.current) {
        unsubscribeRef.current();
      }
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  const fetchBlogs = async () => {
    try {
      const body = {
        apiurl: "/property/single",
        propertyid: propertyid,
        convert: true,
        headers: { "x-access-token": usertoken }
      };
      
      const propertys = await dispatch(fetchData(body));
      
      if (propertys.payload && propertys.payload.status === 200) {
        setProperty(propertys.payload.data);
        setAllHunters(userlist);

        // Initialize map
        const map = new mapboxgl.Map({
          container: 'map-container',
          style: selectedmapstyles,
          center: propertys.payload.data.latlng.lat ? 
            [propertys.payload.data.latlng.lng, propertys.payload.data.latlng.lat] : [0, 0],
          zoom: propertys.payload.data.zoomlevel || 10
        });

        mapRef.current = map;

        // Initialize draw control
        const draw = new MapboxDraw({
          displayControlsDefault: false,
          modes: {
            ...MapboxDraw.modes
          },
          defaultMode: 'draw_polygon',
          styles: [
            {
              id: "gl-draw-polygon-fill-inactive",
              type: "fill",
              paint: {
                "fill-color": propertys.payload.data.propertycolor,
                "fill-outline-color": propertys.payload.data.propertycolor,
                "fill-opacity": 0.1
              }
            },
            {
              id: "gl-draw-polygon-stroke-inactive",
              type: "line",
              paint: {
                "line-color": propertys.payload.data.propertycolor,
                "line-dasharray": [2, 2],
                "line-width": 2,
                "line-opacity": 0.7
              }
            }
          ]
        });

        drawRef.current = draw;

        map.on('load', () => {
          setMapLoaded(true);
          drawPropertyBoundaries(map, propertys);
          
          // Add custom control (button) after map is loaded
          map.addControl(new SendNotificationButtonControl(), 'top-right');
          
          // Setup Firebase listener after map is loaded
          setupFirebaseListener(map, propertys);
        });
      }
    } catch (error) {
      console.error("Error fetching property data:", error);
    }
  };

  const inputsHandler = (e) => {
    setstepInputField((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value
    }));
  };

  const inputsHandlerAll = (e) => {
    setStepAll((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value
    }));
  };

  class SendNotificationButtonControl {
    onAdd(map) {
      this._map = map;
      this._container = document.createElement('div');
      this._container.className = 'mapboxgl-ctrl-group mapboxgl-ctrl';
      this._container.innerHTML = '<button class="send-all-btn">Send Notification to All Hunters</button>';
      this._container.onclick = handleSendToAll;
      return this._container;
    }

    onRemove() {
      this._container.parentNode.removeChild(this._container);
      this._map = undefined;
    }
  }

  return (
    <>
      <div className="realdetails-div">
        <div className="map-div slot-prodiv">
          <div
            id="map-container"
            style={{ width: "100%", height: "803px", borderRadius: "10px" }}
          />
        </div>
      </div>

      {popup && (
        <div className="realdetails-popup">
          <div className="realdetails-content-all ">
            <div className="realdetails-top">
              <h1>Send notification to all hunters</h1>
              <i className="fa-solid fa-xmark" onClick={handleClosepopup}></i>
            </div>
            <div className="real-areadiv">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label required"
              >
                Message
              </label>
              <div className="form-floating">
                <textarea
                  className="form-control"
                  placeholder="Leave a comment here"
                  id="floatingTextarea2"
                  name="description"
                  onChange={inputsHandlerAll}
                  value={setStepAllDescription.description}
                ></textarea>
                <label htmlFor="floatingTextarea2">Send Message...</label>
              </div>
            </div>
            <div className="realsave-btndiv">
              <button className="add-btn" onClick={sendMessageToAll}>Send</button>
            </div>
          </div>
        </div>
      )}

      {realpopup && (
        <div className="realdetails-popup">
          <div className="realdetails-content ">
            <div className="realdetails-top">
              <h1>Hunter Details</h1>
              <i className="fa-solid fa-xmark" onClick={handleClosepopup}></i>
            </div>

            <div className="realdetails-contentmain">
              <div className="realdetails-contentdiv1">
                <p className="th-p">Hunter Name</p>
                <p className="td-p">{selectedhunter.firstname} {selectedhunter.lastname}</p>
              </div>

              <div className="realdetails-contentdiv1">
                <p className="th-p">Email</p>
                <p className="td-p">{selectedhunter.email}</p>
              </div>

              <div className="realdetails-contentdiv1">
                <p className="th-p">Phone No</p>
                <p className="td-p">{selectedhunter.phonenumber}</p>
              </div>
            </div>
            <div className="real-areadiv">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label required"
              >
                Message
              </label>
              <div className="form-floating">
                <textarea
                  className="form-control"
                  placeholder="Leave a comment here"
                  id="floatingTextarea2"
                  name="description"
                  onChange={inputsHandler}
                  value={stepinputField.description}
                ></textarea>
                <label htmlFor="floatingTextarea2">Send Message...</label>
              </div>
            </div>
            <div className="realsave-btndiv">
              <button className="add-btn" onClick={handleSend}>Send</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}